/* eslint-disable */
import { useTranslation as useUiTranslation } from "react-i18next";
import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import API from "../../../utils/api-client";
import APIVERCEL from "../../../utils/api-client-vercel";

const OTPVerificationModal = ({
  isOpen,
  onClose,
  phone,
  onUpdatePhoneNumber,
  isVerified,
  setIsVerified,
}) => {
  const { t: uiT } = useUiTranslation();
  const [step, setStep] = useState(1);
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState(phone);

  useEffect(() => {
    setPhoneNumber(phone);
  }, [phone]);

  const isPhoneValid = /^0\d{9}$/.test(phoneNumber);
  const isPhoneChanged = phoneNumber !== phone;

  const handleSavePhone = async () => {
    if (!isPhoneValid) {
      await Swal.fire({
        icon: "warning",
        title: uiT("ui.phoneInvalid"),
        text: uiT("ui.phoneFormatHint"),
      });
      return;
    }

    try {
      setLoading(true);
      await onUpdatePhoneNumber(phoneNumber);
      await Swal.fire({
        icon: "success",
        title: uiT("servicePageActivation.cashBack.cashBackActivation.alerts.success.saved.title"),
        text: uiT("ui.phoneUpdated"),
        timer: 2000,
        showConfirmButton: false,
      });
    } catch (error) {
      await Swal.fire({
        icon: "error",
        title: uiT("error"),
        text: uiT("ui.phoneUpdateError"),
      });
    } finally {
      setLoading(false);
    }
  };

  const handleSendOTP = async () => {
    try {
      setLoading(true);
      const response = await API.post("digital/vendors/auth/send-otp", {
        phone: phoneNumber,
      });
      setStep(2);
      await Swal.fire({
        icon: "success",
        title: uiT("foorcall_stats.payment.success_title"),
        text: uiT("ui.verificationSent"),
        timer: 2000,
        showConfirmButton: false,
      });
    } catch (error) {
      await Swal.fire({
        icon: "error",
        title: uiT("error"),
        text: uiT("ui.verificationSendError"),
      });
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyOTP = async () => {
    if (otp.length !== 6) {
      await Swal.fire({
        icon: "warning",
        title: uiT("ui.wrongCode"),
        text: uiT("ui.sixDigitCode"),
      });
      return;
    }

    try {
      setLoading(true);
      const response = await APIVERCEL.post("digital/vendors/auth/verify-otp", {
        otp,
      });

      if (response.status === 200) {
        await Swal.fire({
          icon: "success",
          title: uiT("domain-card.status.verified"),
          text: uiT("ui.phoneVerified"),
          timer: 2000,
          showConfirmButton: false,
        });
        setIsVerified(true);
        handleClose(isVerified);
      } else {
        await Swal.fire({
          icon: "error",
          title: uiT("ui.wrongCode"),
          text: uiT("ui.wrongCodeRetry"),
        });
      }
    } catch (error) {
      await Swal.fire({
        icon: "error",
        title: uiT("error"),
        text: uiT("ui.verificationError"),
      });
    } finally {
      setLoading(false);
    }
  };

  const handleClose = (isVerified) => {
    setStep(1);
    setOtp("");
    setLoading(false);
    onClose(isVerified);
  };

  const handleOtpChange = (e) => {
    const value = e.target.value.replace(/\D/g, "");
    if (value.length <= 6) {
      setOtp(value);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white dark:!bg-[#1f1f1f] rounded-lg p-6 w-full max-w-md mx-4 shadow-lg border border-gray-200 dark:!border-gray-700 transition-colors duration-300">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold text-gray-800 dark:text-gray-200">
            {uiT("ui.verifyPhoneFirst")}
          </h2>
          <button
            onClick={handleClose}
            className="text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
            disabled={loading}
          >
            ✕
          </button>
        </div>

        {step === 1 ? (
          <div>
            <p className="text-gray-600 dark:text-gray-400 mb-2">
              {uiT("ui.whatsappCodeHint")}
            </p>
            <input
              type="tel"
              value={phoneNumber}
              onChange={(e) => {
                const val = e.target.value.replace(/\D/g, "");
                if (val.length <= 10) setPhoneNumber(val);
              }}
              placeholder="0XXXXXXXXX"
              className="w-full p-3 border border-gray-300 dark:!border-gray-600 rounded-lg mb-4 focus:outline-none focus:ring-2 focus:ring-[#9e68ba] bg-white dark:!bg-[#2a2a2a] text-center font-mono text-lg text-gray-800 dark:text-gray-100"
              disabled={loading}
            />
            {isPhoneChanged && (
              <button
                onClick={handleSavePhone}
                disabled={loading || !isPhoneValid}
                className="w-full bg-blue-500 hover:bg-blue-600 text-white py-2 px-4 rounded-lg mb-2 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {loading ? uiT("navbar.try.saving") : uiT("ui.saveNewPhone")}
              </button>
            )}

            <button
              onClick={handleSendOTP}
              disabled={loading || !isPhoneValid}
              className="w-full bg-[#9e68ba] hover:bg-[#814a9f] text-white py-2 px-4 rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {loading ? uiT("services.foorCall.submitting") : uiT("ui.sendVerification")}
            </button>
          </div>
        ) : (
          <div>
            <p className="text-gray-600 dark:text-gray-400 mb-4">
              {uiT("ui.enterCode")}
            </p>
            <input
              type="text"
              value={otp}
              onChange={handleOtpChange}
              placeholder="000000"
              className="w-full p-3 border border-gray-300 dark:!border-gray-600 rounded-lg text-center text-2xl font-mono mb-4 focus:outline-none focus:ring-2 focus:ring-[#9e68ba] bg-white dark:!bg-[#2a2a2a] text-gray-800 dark:text-gray-100"
              maxLength={6}
              disabled={loading}
            />
            <div className="flex space-x-2 space-x-reverse">
              <button
                onClick={() => setStep(1)}
                disabled={loading}
                className="flex-1 bg-gray-500 hover:bg-gray-600 text-white py-2 px-4 rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {uiT("foorchat.chats.back")}
              </button>
              <button
                onClick={handleVerifyOTP}
                disabled={loading || otp.length !== 6}
                className="flex-1 bg-green-500 hover:bg-green-600 text-white py-2 px-4 rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {loading ? uiT("ui.verifying") : uiT("Products.Table.otp.verify")}
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default OTPVerificationModal;
